import { SSRV2RuleListItem } from "../../../../integrated-client/models";

interface ISSRTableData {
  records: Array<SSRV2RuleListItem>;
  totalItems?: number;
}

export class SSRTableData implements ISSRTableData {
  records: Array<SSRV2RuleListItem>;
  totalItems?: number;

  constructor() {
    this.records = [];
  }
}
